export interface PulseSurveyNotification {
    preferenceId: string;
    preferenceType?: string;
    label: string;
    createdBy: string;
    createdTimestamp?: string;
    information: PulseSurveyNotificationInformation;
    associationId?: string;
}

export interface PulseSurveyNotificationInformation {
    notificationLabel: string;
    notificationText: string;
    notificationDisplayType: {
        label: string;
        value: string;
    };
    surveyId: string;
    dismissible: boolean;
    autoPopup?: boolean;
    autoPopupMaxCount?: number;
    autoPopupDelayType?: string; // 'none' | 'time-on-page' | 'session-time'
    autoPopupDelaySeconds?: number;
    actionTrigger?: string; // 'none' | 'publish' | 'execute' | 'submit'
    selectedDisplay: {
        label: string;
        value: string;
    };
    closePortalOwners?: any[];
    urlPrefixes?: any[];
    bannerApps?: any[];
    surveys?: any[];
}

export interface PulseSurveyNotificationFromPreference {
    preferenceId: string;
    label: string;
    createdBy: string;
    createdTimestamp: string;
    information: string;
}

export interface PreferenceSuccessResponse {
    data: {
        listPreference: {
            items: PulseSurveyNotificationFromPreference[]
        }
    }
}

export interface PreferenceByTypeSuccessResponse {
    data: {
        listPreferenceByPreferenceType: {
            items: PulseSurveyNotificationFromPreference[]
        }
    }
}

export type PulseSurveyNotificationAssociationId = number | string;

export enum PulseSurveyNotificationDisplayLocation {
    Everywhere = "Everywhere",
    App = "App",
    ClosePortal = "ClosePortal",
    UrlPrefix = "UrlPrefix",
    Trigger = "Trigger"
}

export interface PulseSurveyNotificationParameters {
    closePortalOwnerId?: string;
    appId?: string;
    urlPrefix?: string;
}

export interface PulseSurveyNotificationContainerProps {
    displayLocations: PulseSurveyNotificationDisplayLocation[];
    parameters?: PulseSurveyNotificationParameters;
    roundedCorners?: boolean;
}

export interface PulseSurveyNotificationPropsOptions {
    roundedCorners?: boolean;
    onDismiss?: () => void;
}

export interface PulseSurveyNotificationProps {
    notificationText: string;
    notificationDisplayType: string;
    surveyId: string;
    autoPopup?: boolean;
    autoPopupMaxCount?: number;
    autoPopupDelayType?: string;
    autoPopupDelaySeconds?: number;
    notificationId?: string;
    userId?: string;
    onAutoPopupShown?: (notificationId: string) => void;
    hideBanner?: boolean;
    options?: PulseSurveyNotificationPropsOptions;
}
